import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'
import { ResultsCard } from 'libs/searchspring/components/ResultCard'
import Icon from '@/components/snippets/icon/icon'
import { useSearchImage } from '../../hooks/useSearchImage'
import clsx from 'clsx'

export function QuickSearchResults() {
  const { results } = useSearchspringContext()
  const redirect = results?.merchandising?.redirect
  const { resourceImage } = useSearchImage(redirect)
  const hasProducts = results?.results?.length > 0
  let redirectTitle = ''

  if (results?.results?.length === 0 && !redirect) return null

  if (redirect) {
    redirectTitle = redirect.split('/').pop().split('-')
    redirectTitle = redirectTitle.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
  }

  const mobileRows = `repeat(${results?.results?.length > 1 ? '2' : '1'}, minmax(0, 1fr))`

  return (
    <div className="grid w-full grid-cols-2 grid-rows-[--mb-rows] lg:grid-rows-1 overflow-hidden [grid-auto-rows:0] px-0 bg-neutral-medium gap-1px p-1px lg:px-1px lg:pt-0 lg:pl-0 lg:grid-cols-3 xl:grid-cols-4"
      style={{ '--mb-rows': mobileRows }}
    >
      {redirect ? (
        <>
          <div className="relative flex w-full bg-white group/card">
            <div className="flex flex-col justify-center w-full max-w-full gap-2 overflow-hidden ">
              <div className={clsx('flex relative items-center justify-center w-full h-full max-w-full overflow-hidden aspect-4/5 bg-neutral-medium')}>
                {resourceImage ? (
                  <img src={resourceImage} alt={redirectTitle} className="object-cover w-full h-full" />
                ) : (
                  <div className={'w-[14rem] h-auto'}>
                    <PageIcon />
                  </div>
                )}
              </div>
              <div className="relative z-0 grow flex-row items-start justify-start p-4 lg:p-6 lg:pb-10 rounded-none !h-fit teeth bg-brand-white">
                <a href={redirect} className="justify-start items-center py-2 gap-2 !no-underline btn-inline btn btn-primary-text">
                  <span className="group-hover/card:show-wavy-underline wavy-underline after:-bottom-1">
                    {redirectTitle}
                  </span>
                  <Icon id="arrow-right" className="icon-sm" />
                </a>
              </div>
            </div>
            <a href={redirect} className="absolute inset-0"></a>
          </div>
          {hasProducts ? (
            results?.results?.map((result, index) => (
              <ResultsCard key={result.handle} result={result} options={{ hideQuickAdd: true }} className="flex w-full bg-white" dataIndex={index} />
            ))
          ) : (
            <div className={'bg-brand-white col-span-1 lg:col-span-2 xl:col-span-3'}></div>
          )}
        </>
      ) : (
        results?.results?.map((result, index) => (
          <ResultsCard key={result.handle} result={result} options={{ hideQuickAdd: true }} className="flex w-full bg-white" dataIndex={index} />
        ))
      )}
    </div>
  )
}

const PageIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"/><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"/><path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"/></svg>
)
